import api from '../utils/request';
import { extractErrorMessage } from '../utils/apiErrorHandler';

class FeedbackAPI {
  async create(userId, score, comment) {
    try {
      const score_10 = score * 2;
      
      const response = await api.post('/feedback/', {
        score: score_10,
        comment: comment || null
      });
      
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '创建反馈失败');
    }
  }
}

const feedbackAPI = new FeedbackAPI();
export default feedbackAPI;


